<mat-card-header>
	<mat-card-title class="h5">
		Roles
	</mat-card-title>
</mat-card-header>
<mat-divider> </mat-divider>

<div *ngIf="results.length > 0" class="margin-top-md">
	<div class="row">
		<mat-form-field class="col-lg-12">
			<mat-label>
				Filter
			</mat-label>
			<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
				(ngModelChangeDebounced)="setFilter()" />
		</mat-form-field>
	</div>
	<mat-table [dataSource]="tableDataSources[0]" class="table-responsive mat-elevation-z1" matSort>
		<form [formGroup]="editingForm">
			<ng-container matColumnDef="EDIT">
				<mat-header-cell *matHeaderCellDef> </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div *ngIf="element.ID !== editingId">
						<button mat-icon-button color="primary" (click)="editRole(element)" matTooltip="Edit">
							<mat-icon>edit</mat-icon>
						</button>
						<confirm-popover [buttonType]="'mini-icon'" [icon]="'delete'" [color]="'warn'"
							[popoverMsg]="'Delete Confirmation'" [popoverConfirmText]="'Delete'"
							[popoverConfirmColor]="'warn'" [tooltip]="'Delete'" (onConfirm)="deleteRole(element)">
						</confirm-popover>
					</div>
					<div *ngIf="element.ID === editingId">
						<confirm-popover [buttonType]="'mini-icon'" [icon]="'check'" [color]="'primary'"
							[popoverMsg]="'Update Role'" [popoverConfirmText]="'Confirm'"
							[popoverConfirmColor]="'primary'" [tooltip]="'Update'" (onConfirm)="confirmEditRole()"
							[disabled]="!editingForm.valid">
						</confirm-popover>

						<confirm-popover [buttonType]="'mini-icon'" [icon]="'close'" [color]="'warn'"
							[popoverMsg]="'Cancel?'" [popoverConfirmText]="'Yes'" [popoverCancelText]="'No'"
							[popoverConfirmColor]="'primary'" [tooltip]="'Cancel'" (onConfirm)="cancelEditRole()">
						</confirm-popover>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="ACTIVE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Active </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div *ngIf="element.ID !== editingId">
						<button class="cursor-default" mat-icon-button color="primary" *ngIf="element.ACTIVE === 1"
							[disableRipple]="true">
							<mat-icon>check</mat-icon>
						</button>
						<button class="cursor-default" mat-icon-button color="warn" *ngIf="element.ACTIVE === 0"
							[disableRipple]="true">
							<mat-icon>close</mat-icon>
						</button>
					</div>
					<div *ngIf="element.ID === editingId">
						<mat-button-toggle-group name="roleActive" formControlName="active" aria-label="Role Active"
							hideSingleSelectionIndicator="true">
							<mat-button-toggle [value]="1">
								<mat-icon>check</mat-icon>
							</mat-button-toggle>
							<mat-button-toggle [value]="0">
								<mat-icon>close</mat-icon>
							</mat-button-toggle>
						</mat-button-toggle-group>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="NAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngIf="element.ID !== editingId">
						{{element.NAME}}
					</div>
					<div *ngIf="element.ID === editingId" class="col-lg-12">
						<mat-form-field class="mat-form-field-padding w-100">
							<mat-label>
								Name
							</mat-label>
							<input matInput type="string" placeholder="Role Name" formControlName="name" />
						</mat-form-field>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="DESCRIPTION">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Description </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngIf="element.ID !== editingId">
						{{element.DESCRIPTION}}
					</div>
					<div *ngIf="element.ID === editingId" class="col-lg-12">
						<mat-form-field class="mat-form-field-padding w-100">
							<mat-label>
								Description
							</mat-label>
							<textarea matInput type="string" placeholder="Role Description"
								formControlName="description"></textarea>
						</mat-form-field>
					</div>
				</mat-cell>
			</ng-container>
		</form>

		<ng-container matColumnDef="ADD" disabled>
			<mat-header-cell *matHeaderCellDef>
				<div *ngIf="!adding">
					<button mat-raised-button color="primary" (click)="addRole()">New Role</button>
				</div>
			</mat-header-cell>
		</ng-container>

		<form [formGroup]="addingForm">
			<ng-container matColumnDef="ADD_EDIT" disabled>
				<mat-header-cell *matHeaderCellDef>
					<div *ngIf="adding">
						<confirm-popover [buttonType]="'mini-icon'" [icon]="'add'" [color]="'primary'"
							[popoverMsg]="'Add new Role'" [popoverConfirmText]="'Add'" [popoverConfirmColor]="'primary'"
							[tooltip]="'Add'" (onConfirm)="confirmAddRole()" [disabled]="!addingForm.valid">
						</confirm-popover>
						<confirm-popover [buttonType]="'mini-icon'" [icon]="'close'" [color]="'warn'"
							[popoverMsg]="'Cancel?'" [popoverConfirmText]="'Yes'" [popoverCancelText]="'No'"
							[popoverConfirmColor]="'primary'" [tooltip]="'Cancel'" (onConfirm)="cancelAddRole()">
						</confirm-popover>
					</div>
				</mat-header-cell>
			</ng-container>

			<ng-container matColumnDef="ADD_ACTIVE">
				<mat-header-cell *matHeaderCellDef>
					<mat-button-toggle-group name="roleActive" formControlName="active" aria-label="Role Active"
						hideSingleSelectionIndicator="true">
						<mat-button-toggle [value]="1">
							<mat-icon>check</mat-icon>
						</mat-button-toggle>
						<mat-button-toggle [value]="0">
							<mat-icon>close</mat-icon>
						</mat-button-toggle>
					</mat-button-toggle-group>
				</mat-header-cell>
			</ng-container>

			<ng-container matColumnDef="ADD_NAME">
				<mat-header-cell *matHeaderCellDef class="row">
					<div class="col-lg-12">
						<mat-form-field class="mat-form-field-padding w-100">
							<mat-label>
								Name
							</mat-label>
							<input matInput type="string" placeholder="Role Name" formControlName="name" />
						</mat-form-field>
					</div>
				</mat-header-cell>
			</ng-container>

			<ng-container matColumnDef="ADD_DESCRIPTION">
				<mat-header-cell *matHeaderCellDef class="row">
					<div class="col-lg-12">
						<mat-form-field class="mat-form-field-padding w-100">
							<mat-label>
								Description
							</mat-label>
							<textarea matInput type="string" placeholder="Role Description"
								formControlName="description"></textarea>
						</mat-form-field>
					</div>
				</mat-header-cell>
			</ng-container>
		</form>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matHeaderRowDef="newDisplayedColumns"></mat-row>
		<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
	</mat-table>

</div>